module.exports = function(shared){

  var $mdDialog = shared.$mdDialog;
  var vm = shared.vm;
  var Role_Account_Manager = shared.Role_Account_Manager;

  var topup = vm.topup = {};

  topup.init = function(){
    $mdDialog.open({
      partial: 'account-topup',
      data:{
        member: vm.member,
        account: vm.viewAccount
      }
    });
  };

  topup.details = function(item){
    $mdDialog.open({
      partial: 'topup-details',
      data: {
        topup: item,
        account: vm.viewAccount
      }
    });
  };

  vm.$watch('member',function(member){
    if(!member){
      return;
    }
    topup.paginator = {
      method: Role_Account_Manager.topupList,
      limits:[10,25,50],
      query: {
        memberId: vm.member.id
      }
    };

  });


};
